// extracted by mini-css-extract-plugin
export var button = "_bo-4";
export var hasDarkBackground = "_bo-7";
export var hasLightBackground = "_bo-6";
export var iconWrapper = "_bo-0";
export var large = "_bo-2";
export var medium = "_bo-1";
export var small = "_bo-5";
export var xsmall = "_bo-3";